import React, { useState } from "react";
import InputField from "shared/InputField";
import {
  TKIconEye,
  TKIconPencil,
  TKIconSpinner,
  TKIconViewEye,
} from "assets/images/svgs";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { ngoPasswordChange } from "appState/auth/authSlice";
import { toast } from "react-toastify";
import PasswordLength from "shared/PasswordLength";
import { changePasswordValidationSchema } from "validation/ngo/changePasswordSchema";

const NGOInformation = () => {
  const [editing1, setEditing1] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  const dispatch = useDispatch();

  const { isLoading } = useSelector((state) => state.auth);

  const calculateStrength = (value) => {
    let strength = 0;
    if (/\d/.test(value)) {
      strength++;
    }
    if (/[!@#$%^&*]/.test(value)) {
      strength++;
    }
    if (/[A-Z]/.test(value)) {
      strength++;
    }
    if (value.length >= 6) {
      strength++;
    }
    return strength;
  };

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: changePasswordValidationSchema,
    onSubmit: (values) => {
      const body = {
        oldPassword: values.oldPassword,
        password: values.password,
        confirmPassword: values.confirmPassword,
      };
      dispatch(ngoPasswordChange({ password: body.password })).then((data) => {
        if (data?.payload?.status === 200) {
          toast.success("Password edited successfully!");
          setEditing1(false);
        }
      });
    },
  });

  const toggleShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  };
  const toggleShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };
  const toggleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div className="bg-white rounded-md p-8 w-full h-full">
      <div>
        <p className="my-4 font-semibold">Security Details</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="flex justify-start gap-3 flex-wrap">
            <div className="w-full flex flex-col gap-y-2">
              <div className="relative flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Current Password
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type={showOldPassword ? "text" : "password"}
                  name="oldPassword"
                  id="oldPassword"
                  placeholder="*********"
                  onChange={formik.handleChange}
                  onBlur={() => setIsFocused(false)}
                  value={formik.values.oldPassword}
                />
                {showOldPassword ? (
                  <TKIconViewEye
                    onClick={toggleShowOldPassword}
                    className="right-5 top-9 absolute z-2 hover:cursor-pointer"
                  />
                ) : (
                  <TKIconEye
                    onClick={toggleShowOldPassword}
                    className="right-5 top-9 absolute z-2 hover:cursor-pointer"
                  />
                )}
                {formik.touched.oldPassword && formik.errors.oldPassword ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.oldPassword}
                  </p>
                ) : null}
              </div>
              <div className="relative flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  New Password
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type={showNewPassword ? "text" : "password"}
                  name="password"
                  id="password"
                  placeholder="*********"
                  onFocus={() => setIsFocused(true)}
                  onChange={formik.handleChange}
                  onBlur={() => setIsFocused(false)}
                  value={formik.values.password}
                />
                {showNewPassword ? (
                  <TKIconViewEye
                    onClick={toggleShowNewPassword}
                    className="right-5 w-4 top-9 absolute z-2 hover:cursor-pointer"
                  />
                ) : (
                  <TKIconEye
                    onClick={toggleShowNewPassword}
                    className="right-5 w-4 top-9 absolute z-2 hover:cursor-pointer"
                  />
                )}
                {formik.touched.password && formik.errors.password ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.password}
                  </p>
                ) : null}
                <div className="flex justify-between mt-[10px]">
                  <PasswordLength
                    className={`strength-bar ${
                      isFocused ? "block" : "hidden"
                    } ${
                      calculateStrength(formik.values.password) === 1
                        ? "bg-red-500"
                        : calculateStrength(formik.values.password) === 2
                        ? "bg-yellow-500"
                        : calculateStrength(formik.values.password) === 3
                        ? "bg-yellow-500"
                        : calculateStrength(formik.values.password) >= 4
                        ? "bg-green-500"
                        : "bg-red-500"
                    }`}
                  />
                  <PasswordLength
                    className={`strength-bar ${
                      isFocused ? "block" : "hidden"
                    } ${
                      calculateStrength(formik.values.password) === 2
                        ? "bg-yellow-500"
                        : calculateStrength(formik.values.password) === 3
                        ? "bg-yellow-500"
                        : calculateStrength(formik.values.password) >= 4
                        ? "bg-green-500"
                        : ""
                    }`}
                  />
                  <PasswordLength
                    className={`strength-bar ${
                      isFocused ? "block" : "hidden"
                    } ${
                      calculateStrength(formik.values.password) === 3
                        ? "bg-yellow-500"
                        : calculateStrength(formik.values.password) >= 4
                        ? "bg-green-500"
                        : ""
                    }`}
                  />
                  <PasswordLength
                    className={`strength-bar ${
                      isFocused ? "block" : "hidden"
                    } ${
                      calculateStrength(formik.values.password) >= 4
                        ? "bg-green-500"
                        : ""
                    }`}
                  />
                </div>
              </div>
              <div className="relative flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Confirm Password
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  id="confirmPassword"
                  placeholder="*********"
                  onChange={formik.handleChange}
                  onBlur={() => setIsFocused(false)}
                  value={formik.values.confirmPassword}
                />
                {showConfirmPassword ? (
                  <TKIconViewEye
                    onClick={toggleShowConfirmPassword}
                    className="right-5 top-9 absolute z-2 hover:cursor-pointer"
                  />
                ) : (
                  <TKIconEye
                    onClick={toggleShowConfirmPassword}
                    className="right-5 top-9 absolute z-2 hover:cursor-pointer"
                  />
                )}
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                    {formik.errors.confirmPassword}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
          <div
            className={`my-6 flex ${
              editing1 ? "justify-end" : "justify-between"
            }`}
          >
            {!editing1 && (
              <div
                onClick={() => setEditing1(!editing1)}
                className="cursor-pointer w-[80px] flex justify-center items-center border rounded-2xl gap-x-1 p-1 border-[#213874] hover:font-medium"
              >
                <TKIconPencil />
                <p className="text-[#213874]">Edit</p>
              </div>
            )}
            {editing1 && (
              <div className={`flex gap-x-2 ${editing1 && "justify-end"}`}>
                <button
                  onClick={() => setEditing1(!editing1)}
                  type="button"
                  className="w-[100px] h-[50px] bg-[#E0E0E0] p-2 rounded-sm"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="w-[100px] flex items-center justify-center h-[50px] text-white bg-[#61CE70] p-2 rounded-sm"
                >
                  {isLoading ? <TKIconSpinner className="!h-[38px]" /> : "Save"}
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      <div></div>
    </div>
  );
};

export default NGOInformation;
